<template>

  <div class="grid-content bg-purple">


    <div class="grid-content bg-purple">
      <h2 style="float: left;">季度周期</h2>
      <div class="table-box">

        <el-table
          :data="examinePeriodlist"
          height="550"
          border
          style="width: 100%;">
          <el-table-column
            label="季度"
          >
            <template slot-scope="scope">
              {{scope.row.year}}年第({{scope.row.quarter}})季
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.periodStatus ==1">开启</div>
              <div v-else>关闭</div>
            </template>
          </el-table-column>

          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="opentPeriodtotal(scope.row.year,scope.row.quarter)">查看详情</el-button>
              <el-button
                v-if="scope.row.periodStatus == 1"
                size="mini"
                @click="Uploaddeat(scope.row.year,scope.row.quarter)">上传资料</el-button>

            </template>
          </el-table-column>


        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="examinePeriodpageSize"
        :total="examinePeriodtotal"
        @current-change="settexaminePeriod"
      >
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  name: "Cycle",
  data(){
    return {

      examinePeriodlist:[],
      examinePeriodpageSize:10,
      examinePeriodtotal:0,
      examinePeriodpage:1,

    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selectExaminePeriod();
  },
  methods: {
    selectExaminePeriod(){
      let that = this;
      let examinePeriodSelectdata={
         page:this.examinePeriodpage,
         pageSize:this.examinePeriodpageSize,
      }
      this.$axios
        .post('/webapi/examinePeriod/selectExaminePeriod',examinePeriodSelectdata)
        .then(function (res) {

            if(res.data.code==200) {
              that.examinePeriodlist = res.data.data.list
              that.examinePeriodtotal = res.data.data.total
            }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    settexaminePeriod(examinePeriodpage){
      this.examinePeriodpage = examinePeriodpage;
      this.examinePeriodSelect();
    },

    opentPeriodtotal(year,quarter){
      this.$router.push({name:'Uploadlist' , params:{year:year ,quarter:quarter}})
    },
    Uploaddeat(year,quarter){
      this.$router.push({name:'Upload' , params:{year:year ,quarter:quarter}})
    }


  },
  watch: {
    'ExaminePeriod.year'(val){
      this.ExaminePeriod.year = '' + val;
      }
  },
}
</script>

<style scoped>
.el-table .el-button--success {
  background: #109585;
  border-radius: 4px;
  border-color: #109585;
}
.el-table th>.cell {
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/view/Cycle.vue